module.exports = __webpack_public_path__ + "media/img/boxed-bg-28bc67c0.png";